/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { object, string } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useUIDSeed } from 'react-uid';
import ResponsiveImage from '../../../../../components/GraphqlComponents/GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import CustomSlider from './CustomSlider';

function RenderImage({ name, path }) {
    const extension = (name || '').includes('_gif') ? '.gif' : 'x.jpg';
    const newPath = `${path + name + extension}`;

    return (
        <ResponsiveImage
            alt={name}
            path={newPath}
            params={{ desktop: 'quality=100', mobile: 'quality=100' }}
        />
    );
}

function ProductImageCarousel({ product, selectedSku }) {
    if (typeof window === 'undefined') return null;
    const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth);
    const sliderRef = useRef(null);
    const seed = useUIDSeed();
    const productImage = product.productSkus?.find((x) => selectedSku.id === x.id)?.image || {};

    const handleResize = () => {
        setWindowInnerWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <CustomSlider
            refProp={sliderRef}
            showIndex={false}
            breakpointMobile={600}
            middleMode={false}
            slideWidth={windowInnerWidth > 400 ? 295 : 190}
            length={product?.image?.additionalImages?.length + 1}
        >
            {productImage?.name && productImage?.path && (
                <RenderImage name={productImage.name} path={productImage.path} />
            )}
            {!!product.image.additionalImages.length && product.image.additionalImages.map((name) => (
                <RenderImage key={seed(name)} name={name} path={product?.image?.path} />
            ))}
        </CustomSlider>
    );
}

RenderImage.propTypes = {
    name: string.isRequired,
    path: string.isRequired,
};

ProductImageCarousel.propTypes = {
    product: object.isRequired,
    selectedSku: object.isRequired,
};

export default ProductImageCarousel;
